module.exports = __webpack_public_path__ + "img/avatar-s-11.a8541569.png";